import React from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import { GooglePlacesPriceLevel } from 'tripPlanner/types/common'

export const PRICE_LEVEL_LABELS: Record<GooglePlacesPriceLevel, string | null> = {
  PRICE_LEVEL_UNSPECIFIED: null,
  PRICE_LEVEL_FREE: 'Free',
  PRICE_LEVEL_INEXPENSIVE: '$',
  PRICE_LEVEL_MODERATE: '$$',
  PRICE_LEVEL_EXPENSIVE: '$$$',
  PRICE_LEVEL_VERY_EXPENSIVE: '$$$$',
} as const

export const shouldShowPriceLevel = (priceLevel?: GooglePlacesPriceLevel | null): boolean => {
  return !!priceLevel && !!PRICE_LEVEL_LABELS[priceLevel]
}

interface Props {
  priceLevel?: GooglePlacesPriceLevel | null
  size?: 'small' | 'medium' | 'large'
  colour?: App.Design.ContentColour
}

function GooglePlacePriceLevel({
  priceLevel,
  size = 'small',
  colour = 'neutral-two',
}: Props) {
  const label = priceLevel ? PRICE_LEVEL_LABELS[priceLevel] : null

  if (!label) {
    return null
  }

  return (
    <BodyText
      variant={size}
      colour={colour}
      data-testid="google-place-price-level"
    >
      {label}
    </BodyText>
  )
}

export default React.memo(GooglePlacePriceLevel)
